import { h, Component } from 'preact';
import Chips from 'preact-material-components/Chips';
import 'preact-material-components/Chips/style.css';

import style from './style';

export default class LinkChip extends Component {
	render() {
		return (
			<a href={this.props.route} class={style.chiplink}>
				<Chips.Chip class={style.chip}>
					<Chips.Text>{this.props.label}</Chips.Text>
				</Chips.Chip>
			</a>
		);
	}
}



// WEBPACK FOOTER //
// ./components/LinkChip/index.js